export enum ShippingMode {
  Edit = 'edit',
  EditBulk = 'edit_bulk',
  Validate = 'validate',
}
